import { TIERS, STATUSES } from './constants';

// Field config drives SponsorFormModal rendering.
// type: 'text' | 'email' | 'tel' | 'number' | 'date' | 'url' | 'textarea' | 'select'
export const SPONSOR_FIELDS = [
  { name: 'business_name', label: 'Business Name *', type: 'text', testid: 'sponsor-business-name' },
  { name: 'contact_name',  label: 'Contact Name',    type: 'text' },
  { name: 'email',         label: 'Email',           type: 'email' },
  { name: 'phone',         label: 'Phone',           type: 'tel' },
  { name: 'tier',          label: 'Tier',            type: 'select', options: TIERS },
  { name: 'amount',        label: 'Amount ($)',      type: 'number', min: 0, step: 50 },
  { name: 'sponsorship_date', label: 'Sponsorship Date', type: 'date' },
  { name: 'renewal_date',  label: 'Renewal Date',    type: 'date', testid: 'sponsor-renewal-date' },
  { name: 'status',        label: 'Status',          type: 'select', options: STATUSES.map((s) => ({ value: s, label: s })) },
  { name: 'website',       label: 'Website',         type: 'url', placeholder: 'https://…' },
  { name: 'logo_url',      label: 'Logo URL (paste image link)', type: 'url', placeholder: 'https://…/logo.png', fullWidth: true },
  { name: 'notes',         label: 'Notes',           type: 'textarea', rows: 3, fullWidth: true },
];
